import { render, staticRenderFns } from "./TextWithImageAndLink.vue?vue&type=template&id=536f873b&scoped=true&"
import script from "./TextWithImageAndLink.vue?vue&type=script&lang=js&"
export * from "./TextWithImageAndLink.vue?vue&type=script&lang=js&"
import style0 from "./TextWithImageAndLink.vue?vue&type=style&index=0&id=536f873b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536f873b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImage: require('/vercel/path0/components/general/AppImage.vue').default,ArrowLink: require('/vercel/path0/components/general/ArrowLink.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default,SelectableBgColor: require('/vercel/path0/components/general/SelectableBgColor.vue').default})
